import React, { useState } from "react";
import {
    TextField,
    Button,
    Snackbar,
    Alert,
    InputAdornment,
} from "@mui/material";
import { Translate, Language, Save } from "@mui/icons-material";
import axios from "axios";
import { create_language } from "../api/API";
import { AdminPage, SectionTitle, GREEN, primaryButtonSx } from "../admin/AdminPageLayout";

function MainAddLanguages() {
    const [language, setLanguage] = useState("");
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const token = localStorage.getItem("token");
    const [errorSnackbar, setErrorSnackbar] = useState({
        open: false,
        message: "",
    });
    const [loading, setLoading] = useState(false);
    const handleLanguageChange = (e) => {
        setLanguage(e.target.value);
    };

    const handleSubmit = async () => {
        if (!language.trim()) {
            setErrorSnackbar({
                open: true,
                message: "กรุณากรอกชื่อภาษา",
            });
            return;
        }

        if (!token) {
            setErrorSnackbar({
                open: true,
                message: "ไม่พบ Token กรุณาเข้าสู่ระบบใหม่",
            });
            return;
        }

        try {
            setLoading(true);
            const payload = {
                local: language.trim(),
            };

            const response = await axios.post(
                create_language,
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                }
            );

            if (response.status === 200) {
                setOpenSnackbar(true);
                setLanguage(""); // รีเซตฟิลด์
            } else {
                setErrorSnackbar({
                    open: true,
                    message: `เกิดข้อผิดพลาด: ${response.statusText}`,
                });
            }
        } catch (err) {
            console.error("❌ Error:", err);
            setErrorSnackbar({
                open: true,
                message: "เกิดข้อผิดพลาดในการเชื่อมต่อหรือ Token ไม่ถูกต้อง",
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <AdminPage
                maxWidth={640}
                icon={<Translate fontSize="large" />}
                title="เพิ่มภาษาใหม่"
                subtitle="เพิ่มภาษาที่ระบบรองรับสำหรับการแสดงผลเนื้อหา"
                actions={
                    <Button
                        variant="contained"
                        size="large"
                        startIcon={<Save />}
                        sx={primaryButtonSx}
                        onClick={handleSubmit}
                    >
                        บันทึกภาษา
                    </Button>
                }
            >
                <SectionTitle step={1} title="ข้อมูลภาษา" />
                <TextField
                    label="ชื่อภาษา (เช่น Thai, English, 中文)"
                    variant="outlined"
                    fullWidth
                    value={language}
                    onChange={(e) => setLanguage(e.target.value)}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <Language sx={{ color: GREEN }} />
                            </InputAdornment>
                        ),
                    }}
                />
            </AdminPage>

            <Snackbar
                open={errorSnackbar.open}
                autoHideDuration={3000}
                onClose={() => setErrorSnackbar({ open: false, message: "" })}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert severity="error" variant="filled" sx={{ fontWeight: 'bold' }}>
                    {errorSnackbar.message}
                </Alert>
            </Snackbar>

            <Snackbar
                open={openSnackbar}
                autoHideDuration={2000}
                onClose={() => setOpenSnackbar(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert
                    onClose={() => setOpenSnackbar(false)}
                    severity="success"
                    variant="filled"
                    sx={{
                        width: '100%',
                        backgroundColor: '#c8e6c9',
                        color: '#2e7d32',
                        fontWeight: 'bold',
                    }}
                >
                    เพิ่มภาษาสำเร็จ
                </Alert>
            </Snackbar>
        </>
    );
}

export default MainAddLanguages